import { useMemo, useState } from "react";
import { eventList, categories } from "@/mocks/chigua";

const tabs = [
  { id: "all", name: "全部" },
  ...categories.map((c) => ({ id: c.id, name: c.name })),
];

export default function Feed() {
  const [active, setActive] = useState("all");
  const [keyword, setKeyword] = useState("");

  const filtered = useMemo(() => {
    let list = eventList;
    if (active !== "all") list = list.filter((e) => e.categoryId === active);
    if (keyword.trim()) {
      const kw = keyword.trim().toLowerCase();
      list = list.filter(
        (e) =>
          e.title.toLowerCase().includes(kw) || e.excerpt.toLowerCase().includes(kw)
      );
    }
    return list;
  }, [active, keyword]);

  return (
    <section id="feed" className="bg-secondary-100/40 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-semibold text-primary-700">
              <i className="ri-broadcast-fill" aria-hidden="true"></i> 前排围观
            </p>
            <h2 className="mt-3 font-display text-3xl text-foreground-900 md:text-4xl">
              最新吃瓜现场
            </h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              热门事件边吃边追,按分类或关键词快速找到你关心的
            </p>
          </div>

          <div className="relative w-full md:w-72">
            <i
              className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"
              aria-hidden="true"
            ></i>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索你想吃的瓜…"
              aria-label="搜索现场"
              className="w-full rounded-full border border-secondary-200 bg-background-50 py-2.5 pl-9 pr-4 text-sm text-foreground-800 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
          </div>
        </div>

        <div className="mt-7 flex flex-wrap gap-2">
          {tabs.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setActive(t.id)}
              className={`rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition ${
                active === t.id
                  ? "bg-primary-500 text-white"
                  : "bg-background-50 text-foreground-600 hover:bg-secondary-200/70 hover:text-primary-700"
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div className="mt-10 rounded-2xl border border-secondary-200 bg-background-50 py-20 text-center">
            <i className="ri-search-eye-line text-5xl text-secondary-300" aria-hidden="true"></i>
            <p className="mt-4 text-foreground-600">没有找到相关现场,换个关键词试试吧</p>
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((e) => (
              <article
                key={e.id}
                className="group flex flex-col overflow-hidden rounded-2xl border border-secondary-200 bg-background-50 transition hover:-translate-y-1 hover:border-primary-300 hover:bg-white"
              >
                <div className="relative aspect-[8/5] overflow-hidden">
                  <img
                    src={e.image}
                    alt={e.title}
                    loading="lazy"
                    className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-semibold text-white backdrop-blur-sm">
                    {e.category}
                  </span>
                  {e.trending && (
                    <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-white">
                      <i className="ri-fire-fill" aria-hidden="true"></i> 热议中
                    </span>
                  )}
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="line-clamp-2 text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-700">
                    {e.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {e.excerpt}
                  </p>
                  <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line" aria-hidden="true"></i> {e.views}
                    </span>
                    <span className="inline-flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line" aria-hidden="true"></i> {e.comments}
                    </span>
                    <span className="ml-auto whitespace-nowrap text-secondary-500">{e.time}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}